import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#bank--und-sparguthaben

	{
		"betrag": schemaBigDecimal,
		"gehoertZuAntragsteller": Antragstellerzuordnung
	}

*/
export const schemaEuropaceBankUndSparguthaben = z.object({
    betrag: z.optional(schemaBigDecimal),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    id: z.string().min(1),
});

export type SchemaEuropaceBankUndSparguthaben = z.infer<typeof schemaEuropaceBankUndSparguthaben>;
